
<section class=" d-flex align-items-center offering z-depth-5 section">
    <div class="container " data-aos="fade-up">
        <div class="section-title">
            <h2>Error in Page Loading.</h2>
            <h4></h4>
            <h5>Please mail to   
                <a  
                href="mailto:asd.support@accenture.com?subject=Error in Loading Portal"                  
                class="text-lowercase font-weight-bold" style="text-decoration:underline"  >
                    asd.support@accenture.com  </a> 

            </h5>



        </div>

        
    </div>
    <section>